import { Component, OnInit } from '@angular/core';
import { ObjectLayoutWidget } from 'ngx-schema-form';
import { getHtmlSchemaForm } from '@hm_app/shared/ng2-sftiny-mce/tinymce.utils';


export let getMultilangSchemaRichText = function (title: string, description: string = null) {
    return {
        type: 'object',
        description: description,
        properties: {
            it: getHtmlSchemaForm('Italiano'),
            en: getHtmlSchemaForm('Inglese'),
            // fr: getHtmlSchemaForm('Francese'),
            // es: getHtmlSchemaForm('Spagnolo'),
            // sq: getHtmlSchemaForm('Albanese'),
            // ar: getHtmlSchemaForm('Arabo'),
            // zh: getHtmlSchemaForm('Cinese'),
            // ro: getHtmlSchemaForm('Rumeno'),
        },
        fieldsets: [
            {
                "fields": [
                    "it",
                    "en",
                    // "fr",
                    // "es",
                ],
                "id": title,
                "title": title,
            }],

    };
};

@Component({
    selector: 'multilangrichtext',
    templateUrl: './multilangrichtext-string.widget.html',
    styleUrls: ['./multilangrichtext-string.widget.css'],
})
export class MultilangRichTextStringWidget extends ObjectLayoutWidget
    implements OnInit {
    private currentPage = null;

    ngOnInit() {
        this.currentPage = 0;
    }

    titleForProperty = function (key) {
        return this.schema.properties[key].title;
    };
}
